import React, { ReactNode, useEffect, useRef } from 'react';
import { CoverlWrapper, CoverSection } from './Cover.styles';
import Image from '@/providers/Image';
import { useRouter } from 'next/router';
import useImagePulse from '@/components/image/imagePulseHook';

export interface BannerInternalProps {
  cover: ImageCoverType;
  children?: ReactNode;
}

const Cover = ({ cover, children, ...props }: BannerInternalProps) => {
  const ref = useRef<HTMLImageElement>(null);
  const router = useRouter();
  const { className, containerRef, handleOnCompleted } = useImagePulse();

  useEffect(() => {
    const handleRouteStart = (url: string) => {
      if (!ref) return;
      if (ref) {
        ref.current?.classList.remove('img-loaded');
      }
    };
    router.events.on('routeChangeStart', handleRouteStart);
    return () => {
      router.events.off('routeChangeStart', handleRouteStart);
    };
  });

  if (!cover) return null;
  return (
    <CoverSection>
      <CoverlWrapper className={className} ref={containerRef}>
        <Image
          ref={ref}
          src={cover.imageUrl}
          alt={cover.title || 'Cover'}
          fill
          priority
          fadeInOnBlur
          placeholder={`data:image/jpeg;base64,${cover.blurDataUrl}`}
          handleOnCompleted={handleOnCompleted}
          {...props}
        />
      </CoverlWrapper>
    </CoverSection>
  );
};

export default Cover;
